import { render } from "./DmClientProductDocumentsV2.vue?vue&type=template&id=6628435e&ts=true"
import script from "./DmClientProductDocumentsV2.vue?vue&type=script&lang=ts"
export * from "./DmClientProductDocumentsV2.vue?vue&type=script&lang=ts"

import "./DmClientProductDocumentsV2.vue?vue&type=style&index=0&id=6628435e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__